import React from 'react';
import { motion } from 'framer-motion';

export const Marquee = () => {
  return (
    <div className="w-full bg-secondary py-6 overflow-hidden border-y border-border/20">
      <div className="relative flex overflow-x-hidden">
        <div className="animate-marquee whitespace-nowrap flex items-center gap-8">
          {[...Array(6)].map((_, i) => (
            <React.Fragment key={i}>
              <span className="text-4xl md:text-6xl font-editorial italic text-white px-8">Precision.</span>
              <span className="text-2xl text-secondary-foreground/50">✦</span>
              <span className="text-4xl md:text-6xl font-editorial text-white px-8">Crisis Management.</span>
              <span className="text-2xl text-secondary-foreground/50">✦</span>
              <span className="text-4xl md:text-6xl font-editorial italic text-white px-8">One Contact.</span>
              <span className="text-2xl text-secondary-foreground/50">✦</span>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};
